/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var principalsByMonthReferenceColumns = [{
  name: 'Отпусната главница',
  render: function render(_ref) {
    var principal = _ref.principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "principal"
    }, principal, " ", currency);
  }
}, {
  name: 'Лихви по погасителен план',
  render: function render(_ref2) {
    var interest = _ref2.interest,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "principal"
    }, interest, " ", currency);
  }
}, {
  name: 'Месец',
  value: 'month_name'
}];